export { default } from './AccountMessagesEmptyContentPanel';



// WEBPACK FOOTER //
// ./app/components/borrowing/accountmessages/AccountMessagesEmptyContentPanel/index.js